export default __webpack_public_path__ + "static/media/get_app_banner.3ac4fe93.png";